import { DayHourTimeZone } from 'enums'
import { useAppSelector } from 'app/hooks'
import { InsightContentSettingType } from 'components/insightContent/types'
import InsightContentType from 'components/insightContent/enum/InsightContentType'

// eslint-disable-next-line import/prefer-default-export
export const useTotalMeasureCount = () => {
  const insightContentData = useAppSelector(
    ({ insightContent }) => insightContent?.contents?.[InsightContentType.TOTAL_MEASURE]
  )

  return insightContentData?.data?.[0]?.results?.[0]?.data?.metrics?.[0]?.dataset?.[0]?.set?.[0]
}

export const useDynamicTotalMeasure = (detailSetting: InsightContentSettingType) => {
  const insightContentData = useAppSelector(
    ({ insightContent }) =>
      insightContent?.contents?.[
        detailSetting.timeZone === DayHourTimeZone.LOCAL
          ? InsightContentType.MEASURE_WITH_LOCAL_TIME
          : InsightContentType.TOTAL_MEASURE
      ]
  )

  return insightContentData?.data?.[0]?.results?.[0]?.data?.metrics?.[0]?.dataset?.[0]?.set?.[0]
}

export const useMeasureWithSentimentCount = () => {
  const insightContentData = useAppSelector(
    ({ insightContent }) => insightContent?.contents?.[InsightContentType.MEASURE_WITH_SENTIMENT]
  )

  return insightContentData?.data?.[0]?.results?.[0]?.data?.metrics?.[0]?.dataset?.[0]?.set?.[0]
}

export const useMeasureWithInsightCount = () => {
  const insightContentData = useAppSelector(
    ({ insightContent }) => insightContent?.contents?.[InsightContentType.MEASURE_WITH_INSIGHTS]
  )

  return insightContentData?.data?.[0]?.results?.[0]?.data?.metrics?.[0]?.dataset?.[0]?.set?.[0]
}

export const useTrendingTotalMeasureCount = () => {
  const insightContentData = useAppSelector(
    ({ insightContent }) => insightContent?.contents?.[InsightContentType.TRENDING_TOTAL_MEASURE]
  )

  return insightContentData?.data?.[0]?.results?.[0]?.data?.metrics?.[0]?.dataset?.[0]?.set?.[0]
}
